import React, { createContext, useState, useContext } from 'react';
import { AuthContext } from './auth-context';
import { useHttp } from 'src/hooks';
import { INotification } from 'src/types/notification';

// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = () => {};

export const NotificationContext = createContext<{
  notifications: INotification[];
  fetchNotifications: () => void;
}>({
  notifications: [],
  fetchNotifications: noop,
});

type NotificationProviderProps = {
  children: React.ReactNode;
};

export const NotificationProvider: React.FC<NotificationProviderProps> = ({ children }) => {
  const { accessToken } = useContext(AuthContext);
  const [notifications, setNotifications] = useState<INotification[]>([]);
  const { sendRequest: requestNotification } = useHttp();

  const fetchNotifications = () =>
    requestNotification({ url: 'notification', accessToken }, (allNotifications: any) => {
      setNotifications(allNotifications);
    });

  return (
    <NotificationContext.Provider value={{ notifications, fetchNotifications }}>
      {children}
    </NotificationContext.Provider>
  );
};
